export interface ImageProcessingConfig {
  maxSizeMB: number
  maxOriginalSizeMB?: number
  maxPixels?: number
  compressionTimeoutMs?: number
  maxWidthOrHeight: number
  initialQuality: number
  minQuality: number
  qualityStep: number
  dimensionStep: number
  minWidthOrHeight: number
  maxRetries: number
  maxConcurrentCompressions: number
}

export interface ProcessedImageResult {
  file: File
  wasCompressed: boolean
  originalSizeBytes: number
  finalSizeBytes: number
  width: number
  height: number
}

export type ProcessingErrorReason =
  | 'invalid-type'
  | 'corrupt'
  | 'size-exceeds-absolute-max'
  | 'dimensions-exceed-max'
  | 'compression-failed'
  | 'compression-timeout'
  | 'dimension-floor-hit'
  | 'aborted'

export class ProcessingError extends Error {
  reason: ProcessingErrorReason

  constructor(reason: ProcessingErrorReason, message: string) {
    super(message)
    this.name = 'ProcessingError'
    this.reason = reason
  }
}